module.exports = __webpack_public_path__ + "img/hospital-buildings.b9b1da41.svg";